var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgInstallment = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M53.571 49.236 39.834 25.022c-1.483-2.668-4.843-3.558-7.511-2.075L9.79 35.696c-2.669 1.482-3.558 4.843-2.076 7.511l22.929 40.52c1.482 2.669 4.842 3.558 7.51 2.076l22.435-12.75c2.669-1.482 3.558-4.842 2.076-7.51l-1.68-3.064"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M53.571 49.236 39.834 25.022c-1.483-2.668-4.843-3.558-7.511-2.075L9.79 35.696c-2.669 1.482-3.558 4.843-2.076 7.511l22.929 40.52c1.482 2.669 4.842 3.558 7.51 2.076l22.435-12.75c2.669-1.482 3.558-4.842 2.076-7.51l-1.68-3.064"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M17.9 31.205 11.1 35.206l28.407 50.012 6.401-4L17.9 31.204Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M60.588 73.053c2.669-1.482 3.558-4.842 2.076-7.51M10.877 35.103 39.24 85.21M40.427 59.416l7.51 13.243M17.696 31.249 46.06 81.356M44.676 57.044l2.866 4.941"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m37.833 47.428-9.685-17.196c-.297-.495-.791-.593-1.285-.396l-2.669 1.582c-.494.296-.593.79-.395 1.284L33.484 49.9c.297.494.791.593 1.285.395l2.669-1.482c.494-.297.691-.89.395-1.384Z"
  }), React.createElement("path", {
    fill: color,
    d: "M72.843 10h-19.47c-2.273 0-4.15 1.878-4.15 4.15V28.68c0 2.273 1.877 4.15 4.15 4.15h2.669c.296 0 .494.198.494.495v5.436c0 .494.593.691.89.395l6.127-6.128c.099-.098.198-.098.395-.098h8.994c2.273 0 4.15-1.878 4.15-4.151V14.15C76.995 11.878 75.117 10 72.844 10Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M57.325 17.273V26h-1.58v-7.189h-.052l-2.041 1.304v-1.449l2.169-1.393h1.504Zm5.442 8.893c-2.105 0-3.362-1.662-3.362-4.521.004-2.851 1.265-4.492 3.362-4.492 2.097 0 3.362 1.645 3.362 4.492 0 2.864-1.257 4.526-3.362 4.521Zm0-1.334c1.091 0 1.768-1.09 1.768-3.187-.004-2.08-.681-3.175-1.768-3.175-1.082 0-1.76 1.095-1.764 3.175-.004 2.096.677 3.187 1.764 3.187Zm6.056-5.378 1.322 2.417 1.342-2.416h1.632l-1.973 3.272L73.153 26H71.53l-1.385-2.357L68.772 26h-1.636l1.994-3.273-1.943-3.273h1.636ZM66.222 40.37l-16.314 1.238 4 6.801c-3.827-.956-9.093-2.652-10.023-2.652-4.237 1.446-2.53 5.072-1.2 6.002l12.824 6.253 5.602 5.601 2.34 2.112c.798 2.39.46 4.69-.74 6.29 0 0 .474.244 4.401 1.2 2.889 0 6.038 5.08 6.703 5.877l1.518 3.037s6.254-4.407 9.111-8.352C87.18 70.002 89 62.39 89 62.39l-5.315-4.556c-.76-2.278-8.352-11.389-8.97-12.224-.673-.908-3.937-5.239-8.493-5.239Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "m55.51 48.01-1.2-6.402h-4.401l3.2 6.001 2.401.4ZM58.31 59.612 44.708 53.61h-.8l17.76 11.056-3.356-5.054Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M49.908 41.607s15.045-1.704 17.653-1.054c5.542 1.409 11.302 9.32 14.019 14.09 2.173 3.901 6.737 7.37 6.737 7.37"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M67.43 50.106c-4.082-1.422-6.4 0-9.269-.766-5.628-1.531-5.187-1.422-10.373-2.735-3.09-.765-5.076-1.203-6.29 1.313-.993 2.079 0 3.391 1.876 4.704 2.317 1.641 11.808 5.58 13.904 6.673.442.22.883.547 1.104.985 1.545 2.188 5.959 8.533 16.332 5.907M62.711 71.615c.64.64 2.668 1.187 3.201 1.2 4.801 1.2 4.801 2 4.801 2 2 2.401 4.161 5.602 4.802 7.202"
  }));
};
export default SvgInstallment;